/**
 * SEÇÃO 9: GARANTIA 30 DIAS
 * 
 * Reembolso integral, sem perguntas, processo rápido.
 */

import { memo } from "react";
import { ShieldCheck, MessageCircle } from "lucide-react";

export const GarantiaSection = memo(({ sectionRef, isVisible }) => {
  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="garantia-section"
    >
      <div className="max-w-3xl mx-auto px-4">
        
        <div className="bg-gradient-to-br from-[#009C3B]/10 to-[#009C3B]/5 rounded-3xl p-8 border-2 border-[#009C3B]/20 text-center">
          
          {/* Ícone */}
          <div className="w-20 h-20 rounded-full bg-[#009C3B] flex items-center justify-center mx-auto mb-6 shadow-lg">
            <ShieldCheck className="w-10 h-10 text-white" />
          </div>
          
          {/* Título */}
          <h2 className="text-2xl md:text-3xl font-black text-[#002776] mb-4">
            GARANTIA INCONDICIONAL DE 30 DIAS
          </h2>
          
          {/* Descrição */}
          <p className="text-gray-700 text-lg mb-6 max-w-xl mx-auto">
            Se você desistir antes de usar o voucher, devolvemos <strong className="text-[#009C3B]">100% do valor pago</strong>. 
            Sem perguntas, sem burocracia, processo rápido.
          </p>
          
          {/* Destaque */}
          <div className="bg-white rounded-xl p-4 shadow-md inline-block">
            <p className="text-gray-600 text-sm mb-2">Qualquer problema, fale direto conosco:</p>
            <a 
              href="https://wa.me/5547997920909?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20meu%20voucher"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#25D366] font-bold hover:underline"
            >
              <MessageCircle className="w-5 h-5" />
              (47) 9.9792-0909
            </a>
          </div>
          
        </div>
        
      </div>
    </section>
  );
});

export default GarantiaSection;
